module.exports = __webpack_public_path__ + "static/media/maps.d54c276e.svg";